// -----------------------------------------------------------------------------
// Timezone helpers — Book Away is Australia-only, so every human-facing time
// renders in Sydney local (AEST / AEDT) regardless of the user's browser tz.
//
// Storage stays UTC on the backend (best practice). This module is the SINGLE
// display-layer boundary that converts UTC ISO strings → Sydney-local strings.
// Any component showing a datetime MUST use these helpers rather than calling
// `.toLocaleString()` directly — a Sydney user on a foreign-tz laptop would
// otherwise see the wrong time on their own appointments.
// -----------------------------------------------------------------------------

export const SYDNEY_TZ = "Australia/Sydney";

/** Parse any ISO / Date-shaped input into a JS Date. Returns null on garbage. */
function _toDate(x) {
  if (x == null || x === "") return null;
  const d = x instanceof Date ? x : new Date(x);
  return isNaN(d) ? null : d;
}

/** "Fri 29 Aug" — short day + date, Sydney tz. */
export function fmtSydneyDay(x) {
  const d = _toDate(x);
  if (!d) return "";
  return d.toLocaleDateString(undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
    timeZone: SYDNEY_TZ,
  });
}

/** "2:30 PM" — short time, Sydney tz. */
export function fmtSydneyTime(x) {
  const d = _toDate(x);
  if (!d) return "";
  return d.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    timeZone: SYDNEY_TZ,
  });
}

/** "Aug 29, 2:30 PM" — compact display for booking-request cards. */
export function fmtSydneyDateTime(x) {
  const d = _toDate(x);
  if (!d) return "";
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: SYDNEY_TZ,
  });
}

/** "Fri 29 Aug · 2:30 PM – 3:30 PM" — appointment slot display. */
export function fmtSydneyRange(startX, endX) {
  const s = _toDate(startX);
  const e = _toDate(endX);
  if (!s) return "";
  const day = fmtSydneyDay(s);
  const st = fmtSydneyTime(s);
  const et = e ? fmtSydneyTime(e) : "";
  return et ? `${day} · ${st} – ${et}` : `${day} · ${st}`;
}
